import { useEffect } from 'react';
import styles from './NewOrderAlertV2.module.css';

export default function NewOrderAlertV2({ orders, onClose }) {
    // Auto-dismiss after 10 seconds
    useEffect(() => {
        const timer = setTimeout(onClose, 10000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={styles['new-order-overlay']} onClick={onClose}>
            <div className={styles['new-order-alert']}>
                <h2 className={styles['alert-title']}>NUEVO PEDIDO</h2>

                {orders.map((order, idx) => (
                    <div key={idx} className={styles['alert-order']}>
                        <p className={styles['alert-customer']}>
                            {order.firstName} {order.lastName}
                        </p>
                        <p className={styles['alert-time']}>{order.time}</p>
                        {order.type === 'cake' && (
                            <p className={styles['alert-details']}>
                                {order.cakeSize} • {order.color}
                            </p>
                        )}
                        {order.type === 'bread' && order.bread && (
                            <p className={styles['alert-details']}>
                                {order.bread.map(b => `${b.quantity}x ${b.bread}`).join(', ')}
                            </p>
                        )}
                    </div>
                ))}

                <p className={styles['alert-hint']}>Toca para cerrar</p>
            </div>
        </div>
    );
}
